module.exports = __webpack_public_path__ + "static/media/maestro_mastercard_white.fc3b1538.svg";